export function isApplePayAvailable() {
	return window.ApplePaySession && window.ApplePaySession.canMakePayments();
}
